// src/Callback/Callback.js
import React from 'react';
import { withRouter } from 'react-router';

function Callback(props) {
	console.log('AUTH0 - CALLBACK');
	console.log(props);
  props.auth.handleAuthentication().then(() => {
		//console.log('props.history.push');
    props.history.push('/');
  });

  return (
    <div>
      <p>Chargement du profil...</p>
    </div>
  );
}

export default withRouter(Callback);